import React                           from 'react';
import { ClipLoader }                  from 'react-spinners';
import { Accordion }                   from 'react-bootstrap';
import { withRouter }                  from 'react-router';
import { connect }                     from 'react-redux';
import { EmployeeOnboardingConstants } from '../environment';
import { isLoggedIn, redirect }        from '../../../../utils/authService';
import { notifyFetchData }             from '../../../../actions/employee-onboarding/notify';

var apiHost = EmployeeOnboardingConstants.WebApiHost;
var error   = 'There was an error processing your request.';

class Notify extends React.Component {
    
  constructor(props) {
    super(props);
    this.state = {
      group : ''
    };
    
    this.group = this.group.bind(this);
  }
  
  group() {
    var query = new URLSearchParams(this.props.location.search);
    var group = query.get('group');
    return group;
  }

  componentDidMount() {
    if (!isLoggedIn()) {
      redirect(window.location.hash.replace("#/", ""));
      return;    
    }
    
    var group = this.group();
    this.setState({ group: group }, function() {
      this.props.fetchData(apiHost, group); 
    });
  }

  render() {
    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.notifyIsLoading ?
            <ClipLoader
              color={'#072659'}
              loading={this.props.notifyIsLoading}
            />
            : <span />
          }
        </div>
        { this.props.notifyHasErrored ?
          <Accordion className='well-red'>
            {error}
          </Accordion>
          : <span />
       }
       { !this.props.notifyIsLoading && !this.props.notifyHasErrored ?
          <Accordion>
            Thank you for confirming the membership for <b>{this.state.group}</b>
          </Accordion>
          : <span />
       }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    notify: state.employee.notify.notify,
    notifyHasErrored: state.employee.notify.notifyHasErrored,
    notifyIsLoading: state.employee.notify.notifyIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, group) => dispatch(notifyFetchData(host, group))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notify));
